<script>
/**
 * Ícone plus-square. O desenho é um path único com `fill-rule="evenodd"`:
 * o quadrado arredondado preenchido menos o "+" vazado.
 *
 * Não usar <mask>/<clipPath> aqui. O export do Figma vinha com um id fixo
 * (`mask0_...`) repetido em toda instância do ícone; quando a primeira
 * ocorrência do id cai dentro de um bloco `display: none` — o caso das abas
 * com `v-show` do modal Áreas e Departamentos — o Chrome não constrói o
 * recurso, a máscara não resolve e o <rect> renderiza sem recorte: um
 * quadrado sólido no lugar do ícone.
 */
export default {
  name: 'PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 13H13V15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15V13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H11V9C11 8.45 11.45 8 12 8C12.55 8 13 8.45 13 9V11H15C15.55 11 16 11.45 16 12C16 12.55 15.55 13 15 13ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z"
      :fill="color"
    />
  </svg>
</template>
